import { createAction } from 'redux-actions';
import { SocialLoginProvider } from '../types';
import { reduxKey } from '../constants';
import { PapiDaSignupSigninSigninSocial } from '@wix/da-papi-types';

export const attemptSocialLogin = createAction(
  `${reduxKey}.ATTEMPT_SOCIAL_LOGIN`,
  (params: {
    provider: SocialLoginProvider;
    token: string;
    // Used internally by sisu to do 'login page => join page' redirect
    redirectToJoin?: boolean;
    // Used to redirect from outside (e.g. browse) to sisu's join page
    redirectToSisu?: boolean;
  }) => params
);

export const initializeFacebookJSSDK = createAction(`${reduxKey}.FACEBOOK.INIT`, () => ({}));

export const setSocialLoginError = createAction(
  `${reduxKey}.SET_ERROR`,
  (errorCode: string | undefined) => ({
    errorCode,
  })
);

// Callback actions

export const socialLoginSuccess = createAction(
  `${reduxKey}.LOGIN_SUCCESS`,
  (params: {
    response: PapiDaSignupSigninSigninSocial;
    provider: SocialLoginProvider;
    redirectToJoin?: boolean;
  }) => params
);
